export type TotemStep =
  | 'inicio'
  | 'identificacao'
  | 'cardapio'
  | 'retirada'
  | 'revisao'
  | 'pagamento'
  | 'confirmacao';

export const TOTEM_STEPS: TotemStep[] = [
  'inicio',
  'identificacao',
  'retirada',
  'cardapio',
  'revisao',
  'pagamento',
  'confirmacao',
];

export interface ProdutoCarrinho {
  tipo?: string;
  descricao: any[];
  categoria?: string;
  tamanho?: string;
  quantidadeSabores?: string;
  quantidade: any;
  valor?: string;
  subtotal: string;
  indice?: string;
  impressoraSelecionada?: string;
  observacao?: string;
  salvo?: boolean;
  enviado?: boolean;
}

export interface TotemPedido {
  pk: string;
  sk: string;
  id: string;
  clienteid: string;
  clienteNome: string;
  empresaid: string;
  produtos: ProdutoCarrinho[];
  valorTotal: string;
  valorTotalProdutos: string;
  tipoRetirada: string;
  formaPagamento: string;
  avaliacao: string;
  status: string;
}
